( function( window, $, undefined ) {

	var modulGA = {
		init: function() {

			// Button 'koupit' vpravo nahore
			$( "body > nav > div.navbar-right > div.link-container > a" ).click( function() {
				gtag( "event", "click", {
					hitType: "event",
					event_category: "Button Koupit Knihu",
					event_label: "Top button Koupit"
				} );
			} );

			// Hlavni button 'koupit'
			var selector = [
				"#uvod",
				"div.container.header-text-container.header-bg",
				"div",
				"div.header-text-cta",
				"a"
			];
			$( selector.join( " > " ) )
				.click( function() {
					gtag( "event", "click", {
						event_category: "Button Koupit Knihu",
						event_label: "Main button Koupit"
					} );
				} );

			// Buttonky 'koupit' dole u produktu
			selector = [
				"#produkty",
				"div.container.container-products",
				"div.swiper-container.swiper-container-horizontal",
				"div",
				"div.swiper-slide",
				"div",
				"div.product-item-footer",
				"div.product-item-button",
				"a"
			];
			$( selector.join( " > " ) )
				.click( function() {
					var types = {
						"cup": "Hrnek",
						"shirt": "Tričko",
						"golden_book": "Knihu"
					};
					var pType = $( this ).data( "product_type" );
					if ( pType ) {
						gtag( "event", "click", {
							event_category: "Button Koupit " + types[ pType ],
							event_label: "Down button Koupit"
						} );
					}
				} );
		}
	};

	window.modulGA = modulGA;
} )( window, window.jQuery );
